import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import "./LoginPage.css";
import host from "../config";
const ForgotPassword = () => {
  const [username, setUsername] = useState("");
  const [mobile_number, setMobile_number] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [step, setStep] = useState(1); // 1: Enter mobile number, 2: Enter OTP, 3: Reset password
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSendOtp = async () => {
    try {
      const response = await axios.post(
        `${host}/userotplogin`,
        {
          mobile_number,
          username,
        }
      );

      if (response.data.status === 200) {
        setStep(2);
        setUserId(response.data.data.userId); // Assuming `userId` is correctly returned from API
      } else {
        alert("Invalid Mobile Number or Username");
      }
    } catch (error) {
      console.error("Error sending OTP:", error.message);
    }
  };

  
  const handleVerifyOtp = async () => {
    try {
      console.log("Sending OTP verification request with:", {
        otp,
        username,
        mobile_number,
      });

      const response = await axios.post(
        `${host}/userverifyotp`,
        {
          otp,
          username,
          mobile_number,
        }
      );

      console.log("OTP Verification Response:", response.data);

      if (response.data.status === 200) {
        setStep(3);
      } else {
        alert("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error.message);
    }
  };

  
  const handleUpdatePassword = async () => {
    console.log("handleUpdatePassword called");

    try {
      if (!newPassword || !confirmPassword) {
        alert("Please enter both new password and confirm password.");
        return;
      }

      if (newPassword !== confirmPassword) {
        alert("Passwords do not match.");
        return;
      }

      // Password validation
      if (newPassword.length < 6) {
        alert("New password must be at least 6 characters long.");
        return;
      }
      if (!/[A-Z]/.test(newPassword)) {
        alert("New password must contain at least one uppercase letter.");
        return;
      }
      if (!/[a-z]/.test(newPassword)) {
        alert("New password must contain at least one lowercase letter.");
        return;
      }
      if (!/\d/.test(newPassword)) {
        alert("New password must contain at least one number.");
        return;
      }
      if (!/[@$!%*?&]/.test(newPassword)) {
        alert(
          "New password must contain at least one special character (@$!%*?&)."
        );
        return;
      }

      console.log("Sending update password request:", {
        username,
        password: newPassword,
      });

      const response = await axios.post(
        `${host}/updateuserpassword`,
        {
          username,
          password: newPassword,
        }
      );

      console.log("Update password response:", response);

      if (response.data.status === 200) {
        alert("Password updated successfully!");
        navigate("/Login");
      } else {
        alert("Error updating password.");
      }
    } catch (error) {
      console.error("Error updating password:", error.message);
    }
  };

  return (
    <div>
      <Header />
      {/* <Navbar /> */}

      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="row justify-content-center w-100">
          <div className="col-lg-6 col-md-8 col-sm-10 col-xs-10">
            <h1
              className="text-center"
              style={{ fontSize: "25px", color: "green" }}
            >
              {step === 1
                ? "Forgot Password"
                : step === 2
                  ? "Verify OTP"
                  : "Update Password"}
            </h1>
            <div className="container mt-5">
              {step === 1 && (
                <form className="for-password">
                  <div className="mb-3">
                    <label>Username</label>
                    <input
                      type="text"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3">
                    <label>Mobile Number</label>
                    <input
                      type="text"
                      value={mobile_number}
                      onChange={(e) => setMobile_number(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleSendOtp}
                  >
                    Send OTP
                  </button>
                </form>
              )}
              {step === 2 && (
                <form className="for-password">
                  <div className="mb-3">
                    <label>Enter OTP</label>
                    <input
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleVerifyOtp}
                  >
                    Verify OTP
                  </button>
                </form>
              )}
              {step === 3 && (
                <form className="for-password">
                  <div className="mb-3">
                    <label>New Password:</label>
                    <input
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3">
                    <label>Confirm Password:</label>
                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleUpdatePassword}
                  >
                    Update Password
                  </button>
                </form>
              )}
              {step !== 3 && (
                <div className="mt-3 text-center">
                  <p>
                    Remember your password? <Link to="/Login">Login Here</Link>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
